export type Country = {
  name: string;
  code: string; // ISO 3166-1 codes
};

export const SupportedCountries: Country[] = [
  { code: "af", name: "افغانستان" }, // Afghanistan
  { code: "al", name: "Shqipëria" }, // Albania
  { code: "dz", name: "الجزائر" }, // Algeria
  { code: "ad", name: "Andorra" },
  { code: "ao", name: "Angola" },
  { code: "ar", name: "Argentina" },
  { code: "am", name: "Հայաստան" }, // Armenia
  { code: "au", name: "Australia" },
  { code: "at", name: "Österreich" }, // Austria
  { code: "az", name: "Azərbaycan" }, // Azerbaijan
  { code: "bs", name: "Bahamas" },
  { code: "bh", name: "البحرين" }, // Bahrain
  { code: "bd", name: "বাংলাদেশ" }, // Bangladesh
  { code: "bb", name: "Barbados" },
  { code: "by", name: "Беларусь" }, // Belarus
  { code: "be", name: "België" }, // Belgium
  { code: "bz", name: "Belize" },
  { code: "bj", name: "Bénin" }, // Benin
  { code: "bt", name: "འབྲུག" }, // Bhutan
  { code: "bo", name: "Bolivia" },
  { code: "ba", name: "Bosna i Hercegovina" }, // Bosnia
  { code: "bw", name: "Botswana" },
  { code: "br", name: "Brasil" }, // Brazil
  { code: "bn", name: "Brunei" },
  { code: "bg", name: "България" }, // Bulgaria
  { code: "bf", name: "Burkina Faso" },
  { code: "bi", name: "Burundi" },
  { code: "kh", name: "កម្ពុជា" }, // Cambodia
  { code: "cm", name: "Cameroun" }, // Cameroon
  { code: "ca", name: "Canada" },
  { code: "cv", name: "Cabo Verde" },
  { code: "cf", name: "République centrafricaine" }, // CAR
  { code: "td", name: "تشاد" }, // Chad
  { code: "cl", name: "Chile" },
  { code: "cn", name: "中国" }, // China
  { code: "co", name: "Colombia" },
  { code: "km", name: "Comores" }, // Comoros
  { code: "cg", name: "Congo" },
  { code: "cd", name: "République démocratique du Congo" }, // DRC
  { code: "cr", name: "Costa Rica" },
  { code: "hr", name: "Hrvatska" }, // Croatia
  { code: "cu", name: "Cuba" },
  { code: "cy", name: "Κύπρος" }, // Cyprus
  { code: "cz", name: "Česko" }, // Czech Republic
  { code: "dk", name: "Danmark" }, // Denmark
  { code: "dj", name: "Djibouti" },
  { code: "dm", name: "Dominica" },
  { code: "do", name: "República Dominicana" }, // Dominican Republic
  { code: "ec", name: "Ecuador" },
  { code: "eg", name: "مصر" }, // Egypt
  { code: "sv", name: "El Salvador" },
  { code: "gq", name: "Guinea Ecuatorial" }, // Equatorial Guinea
  { code: "er", name: "ኤርትራ" }, // Eritrea
  { code: "ee", name: "Eesti" }, // Estonia
  { code: "et", name: "ኢትዮጵያ" }, // Ethiopia
  { code: "fj", name: "Fiji" },
  { code: "fi", name: "Suomi" }, // Finland
  { code: "fr", name: "France" },
  { code: "ga", name: "Gabon" },
  { code: "gm", name: "Gambia" },
  { code: "ge", name: "საქართველო" }, // Georgia
  { code: "de", name: "Deutschland" }, // Germany
  { code: "gh", name: "Ghana" },
  { code: "gr", name: "Ελλάδα" }, // Greece
  { code: "gd", name: "Grenada" },
  { code: "gt", name: "Guatemala" },
  { code: "gn", name: "Guinée" }, // Guinea
  { code: "gw", name: "Guiné-Bissau" }, // Guinea-Bissau
  { code: "gy", name: "Guyana" },
  { code: "ht", name: "Haïti" }, // Haiti
  { code: "hn", name: "Honduras" },
  { code: "hu", name: "Magyarország" }, // Hungary
  { code: "is", name: "Ísland" }, // Iceland
  { code: "in", name: "भारत" }, // India
  { code: "id", name: "Indonesia" },
  { code: "ir", name: "ایران" }, // Iran
  { code: "iq", name: "العراق" }, // Iraq
  { code: "ie", name: "Ireland" },
  { code: "il", name: "ישראל" }, // Israel
  { code: "it", name: "Italia" }, // Italy
  { code: "jm", name: "Jamaica" },
  { code: "jp", name: "日本" }, // Japan
  { code: "jo", name: "الأردن" }, // Jordan
  { code: "kz", name: "Қазақстан" }, // Kazakhstan
  { code: "ke", name: "Kenya" },
  { code: "ki", name: "Kiribati" },
  { code: "kp", name: "조선" }, // North Korea
  { code: "kr", name: "대한민국" }, // South Korea
  { code: "kw", name: "الكويت" }, // Kuwait
  { code: "kg", name: "Кыргызстан" }, // Kyrgyzstan
  { code: "la", name: "ລາວ" }, // Laos
  { code: "lv", name: "Latvija" }, // Latvia
  { code: "lb", name: "لبنان" }, // Lebanon
  { code: "ls", name: "Lesotho" },
  { code: "lr", name: "Liberia" },
  { code: "ly", name: "ليبيا" }, // Libya
  { code: "li", name: "Liechtenstein" },
  { code: "lt", name: "Lietuva" }, // Lithuania
  { code: "lu", name: "Luxembourg" },
  { code: "mk", name: "Македонија" }, // North Macedonia
  { code: "mg", name: "Madagasikara" }, // Madagascar
  { code: "mw", name: "Malawi" },
  { code: "my", name: "Malaysia" },
  { code: "mv", name: "ދިވެހިރާއްޖެ" }, // Maldives
  { code: "ml", name: "Mali" },
  { code: "mt", name: "Malta" },
  { code: "mh", name: "Marshall Islands" },
  { code: "mr", name: "موريتانيا" }, // Mauritania
  { code: "mu", name: "Mauritius" },
  { code: "mx", name: "México" }, // Mexico
  { code: "fm", name: "Micronesia" },
  { code: "md", name: "Moldova" },
  { code: "mc", name: "Monaco" },
  { code: "mn", name: "Монгол улс" }, // Mongolia
  { code: "me", name: "Crna Gora" }, // Montenegro
  { code: "ma", name: "المغرب" }, // Morocco
  { code: "mz", name: "Moçambique" }, // Mozambique
  { code: "mm", name: "မြန်မာ" }, // Myanmar
  { code: "na", name: "Namibia" },
  { code: "nr", name: "Nauru" },
  { code: "np", name: "नेपाल" }, // Nepal
  { code: "nl", name: "Nederland" }, // Netherlands
  { code: "nz", name: "New Zealand" },
  { code: "ni", name: "Nicaragua" },
  { code: "ne", name: "Niger" },
  { code: "ng", name: "Nigeria" },
  { code: "no", name: "Norge" }, // Norway
  { code: "om", name: "عُمان" }, // Oman
  { code: "pk", name: "پاکستان" }, // Pakistan
  { code: "pw", name: "Palau" },
  { code: "ps", name: "فلسطين" }, // Palestine
  { code: "pa", name: "Panamá" }, // Panama
  { code: "pg", name: "Papua New Guinea" },
  { code: "py", name: "Paraguay" },
  { code: "pe", name: "Perú" }, // Peru
  { code: "ph", name: "Philippines" },
  { code: "pl", name: "Polska" }, // Poland
  { code: "pt", name: "Portugal" },
  { code: "qa", name: "قطر" }, // Qatar
  { code: "ro", name: "România" }, // Romania
  { code: "ru", name: "Россия" }, // Russia
  { code: "rw", name: "Rwanda" },
  { code: "kn", name: "Saint Kitts and Nevis" },
  { code: "lc", name: "Saint Lucia" },
  { code: "vc", name: "Saint Vincent and the Grenadines" },
  { code: "ws", name: "Samoa" },
  { code: "sm", name: "San Marino" },
  { code: "st", name: "São Tomé e Príncipe" },
  { code: "sa", name: "السعودية" }, // Saudi Arabia
  { code: "sn", name: "Sénégal" }, // Senegal
  { code: "rs", name: "Србија" }, // Serbia
  { code: "sc", name: "Seychelles" },
  { code: "sl", name: "Sierra Leone" },
  { code: "sg", name: "Singapore" },
  { code: "sk", name: "Slovensko" }, // Slovakia
  { code: "si", name: "Slovenija" }, // Slovenia
  { code: "sb", name: "Solomon Islands" },
  { code: "so", name: "Soomaaliya" }, // Somalia
  { code: "za", name: "South Africa" },
  { code: "ss", name: "South Sudan" },
  { code: "es", name: "España" }, // Spain
  { code: "lk", name: "ශ්‍රී ලංකා" }, // Sri Lanka
  { code: "sd", name: "السودان" }, // Sudan
  { code: "sr", name: "Suriname" },
  { code: "se", name: "Sverige" }, // Sweden
  { code: "ch", name: "Schweiz" }, // Switzerland
  { code: "sy", name: "سوريا" }, // Syria
  { code: "tw", name: "台灣" }, // Taiwan
  { code: "tj", name: "Тоҷикистон" }, // Tajikistan
  { code: "tz", name: "Tanzania" },
  { code: "th", name: "ประเทศไทย" }, // Thailand
  { code: "tl", name: "Timor-Leste" },
  { code: "tg", name: "Togo" },
  { code: "to", name: "Tonga" },
  { code: "tt", name: "Trinidad and Tobago" },
  { code: "tn", name: "تونس" }, // Tunisia
  { code: "tr", name: "Türkiye" }, // Turkey
  { code: "tm", name: "Türkmenistan" }, // Turkmenistan
  { code: "tv", name: "Tuvalu" },
  { code: "ug", name: "Uganda" },
  { code: "ua", name: "Україна" }, // Ukraine
  { code: "ae", name: "الإمارات" }, // UAE
  { code: "gb", name: "United Kingdom" },
  { code: "us", name: "United States" },
  { code: "uy", name: "Uruguay" },
  { code: "uz", name: "Oʻzbekiston" }, // Uzbekistan
  { code: "vu", name: "Vanuatu" },
  { code: "va", name: "Città del Vaticano" }, // Vatican
  { code: "ve", name: "Venezuela" },
  { code: "vn", name: "Việt Nam" }, // Vietnam
  { code: "ye", name: "اليمن" }, // Yemen
  { code: "zm", name: "Zambia" },
  { code: "zw", name: "Zimbabwe" },
];

export const findCountryByCode = (code: string): Country | undefined => {
  return SupportedCountries.find((country) => country.code === code);
};

export const findCountryByName = (name?: string): Country | undefined => {
  return SupportedCountries.find((country) => country.name === name);
};
